import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {OrderSummaryContainer} from '../../../../../features/OrderSummary/OrderSummaryContainer'
import {
  selectActiveLocation,
  selectIsUpgrade,
  updateLocation,
} from '../../../../../app-store/PurchaseLinkSlice'
import {selectEffectiveRole} from '../../../../../app-store/selector'
import {usePurchaseLinkProducts} from '../hooks/usePurchaseLinkProducts'
import {usePurchaseLinkPaymentPreview} from '../hooks/usePurchaseLinkPaymentPreview'

// Single-location branch of PurchaseLinkBuilder's OrderSummary (orderMode
// !== 'parentPay') — split out so its hooks (usePurchaseLinkProducts,
// usePurchaseLinkPaymentPreview) only run when this branch actually renders,
// instead of unconditionally in the OrderSummary dispatcher regardless of
// orderMode.
export function LocationOrderSummary({actions}) {
  const dispatch = useDispatch()
  const activeLocation = useSelector(selectActiveLocation)
  const isUpgrade = useSelector(selectIsUpgrade)
  const effectiveRole = useSelector(selectEffectiveRole)
  const userRoles = [effectiveRole].flat().filter(Boolean)

  const {
    selectedCountry,
    selectedProducts,
    handleRemoveProduct,
    isNewTLMCAccessible,
    isNewCustomer,
  } = usePurchaseLinkProducts()
  const {refreshPaymentPreview} = usePurchaseLinkPaymentPreview()

  return (
    <OrderSummaryContainer
      activeItem={activeLocation}
      currentId={activeLocation?.locationId ?? null}
      idFallback="purchase-link"
      thryvId={activeLocation?.thryvId}
      selectedCountry={selectedCountry}
      selectedProducts={selectedProducts}
      handleRemoveProduct={handleRemoveProduct}
      isNewTLMCAccessible={isNewTLMCAccessible}
      isNewCustomer={isNewCustomer}
      isUpgrade={isUpgrade}
      applyNewAccountDefaults
      userRoles={userRoles}
      refreshPaymentPreview={refreshPaymentPreview}
      onUpdateItem={(locationId, changes) =>
        dispatch(updateLocation({locationId, changes}))
      }
      refreshOnItemsLoaded
      isItemLoaded={activeLocation?.isLoaded}
      flushEdges
      actions={actions}
    />
  )
}
